// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // firebase: {
  //   apiKey: 'AIzaSyC908E5f7s_yyVXm-arh6v7UjtCZ0Zb_XI',
  //   authDomain: 'alberti-consumo-agua.firebaseapp.com',
  //   databaseURL: 'https://alberti-consumo-agua.firebaseio.com',
  //   projectId: 'alberti-consumo-agua',
  //   storageBucket: 'alberti-consumo-agua.appspot.com',
  //   messagingSenderId: '616240413513'
  // }
  firebase: {
    apiKey: 'AIzaSyCqWexB8rtYs8_XTwmeynkFlLCzNTgQnXQ',
    authDomain: 'alberti-consumo-agua-backup.firebaseapp.com',
    databaseURL: 'https://alberti-consumo-agua-backup.firebaseio.com',
    projectId: 'alberti-consumo-agua-backup',
    storageBucket: 'alberti-consumo-agua-backup.appspot.com',
    messagingSenderId: '29954884283',
    appId: '1:29954884283:web:86652908d9cf52a8'
  }
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
